/** Copyright (c) 2022-present TVM Engineering Authors. */

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;
